<template>
  <span
    class="tc-conf-bar"
    :class="[`tc-conf-bar--${state}`, variant === 'dot' ? 'tc-conf-bar--dot' : 'tc-conf-bar--bar']"
    :aria-label="stateLabel"
    role="img"
  ></span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

export type ConfidenceState = 'high' | 'med' | 'low' | 'dismissed' | 'confirmed';

const props = defineProps<{
  state: ConfidenceState;
  variant?: 'bar' | 'dot';
}>();

const stateLabel = computed<string>(() => {
  const labels: Record<ConfidenceState, string> = {
    high: 'High confidence',
    med: 'Medium confidence',
    low: 'Low confidence',
    dismissed: 'Dismissed',
    confirmed: 'Confirmed',
  };
  return labels[props.state] ?? props.state;
});
</script>
